import * as React from 'react'
import { SortDirection } from './types'

interface SortIconProps {
  columnKey: string
  sortKey: string | null
  sortDirection: SortDirection
}

export function SortIcon({ columnKey, sortKey, sortDirection }: SortIconProps) {
  const iconStyle = { fontSize: '0.7em' }

  if (sortKey !== columnKey) {
    return <i className="fa fa-sort text-muted ml-1" style={iconStyle} />
  }

  return sortDirection === 'asc' ? (
    <i className="fa fa-sort-up ml-1" style={iconStyle} />
  ) : (
    <i className="fa fa-sort-down ml-1" style={iconStyle} />
  )
}
